import { ListButton, useRecordContext } from 'react-admin';

export const LinkToDocuments = () => {
  const record = useRecordContext();
  const { id } = record;
  return <ListButton to={`/users/${id}/documents`} label={'Documents'} />;
};
